import { __awaiter } from "tslib";
import consoleEvents from '../../consoleEvents';
import { getLocale } from '../../locale';
import request, { getMaintenanceHeader } from '../../request/request';
import { clearLabelsCache } from './getLabelsFromStorage';
import { setLslLabelsOnStorage } from './setLabelsOnStorage';
export const buildLslApiUrl = (lang, country, userId, file) => {
    return `${process.env.LSL_DOMAIN}/lsl-service/api/translation/key/${lang}-${country.toUpperCase()}?compressed=true&userid=${userId}${process.env.LSL_BRAND_ID ? `&brandId=${process.env.LSL_BRAND_ID}` : ''}&mastercopyFallback=true${file ? `&file=${file}` : ''}`;
};
// LSL locales which differ from front-end locales
const mappedLslLocales = {
    no_no: 'nb_no',
};
const fetchLslLabels = (customLocale, userId, shouldStoreDataInClientStorage = true, file, hasMaintenanceHeader, logger) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let mappedData = {};
    if (!userId)
        return mappedData;
    const locale = customLocale || getLocale();
    const [lang, country] = (_a = (mappedLslLocales[locale] || locale)) === null || _a === void 0 ? void 0 : _a.split('_');
    if (!lang || !country)
        return mappedData;
    try {
        const response = yield request.get(buildLslApiUrl(lang, country, userId, file), {
            headers: Object.assign({ 'lsl-api-key': process.env.LSL_API_KEY, 'lsl-akamai-key': process.env.LSL_AKAMAI_KEY }, (hasMaintenanceHeader && getMaintenanceHeader())),
            shouldRemoveData: true,
        });
        // map array of objects to object of keys and their translations to be consistent with AEM and Hybris
        mappedData = Object.assign({}, ...response === null || response === void 0 ? void 0 : response.data.data.map((item) => ({ [item.key]: item.translation })));
        if (shouldStoreDataInClientStorage) {
            setLslLabelsOnStorage(mappedData, userId, locale, file);
        }
        clearLabelsCache();
        logger === null || logger === void 0 ? void 0 : logger.info(response, 'fetchLslLabels success');
    }
    catch (e) {
        consoleEvents.error(e, e);
        logger === null || logger === void 0 ? void 0 : logger.error(e, 'fetchLslLabels error');
    }
    return mappedData;
});
export default fetchLslLabels;
//# sourceMappingURL=fetchLslLabels.js.map